<template>
    <v-container>
      <v-card class="mx-auto" flat>
        <v-row >
          <v-col>
            <p class="headline font-weight-bold text-center" style="color:#AF8936; font-size: 27px !important;">
              Estadísticas Reportes
            </p>
          </v-col>
        </v-row>

        <v-row class="mb-n7">
        <v-col class="" cols="6" md="6">
          <v-menu
            ref="dialogFecInicio"
            v-model="dialogFecInicio"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
            >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fecha_inicio"
                label="Fecha Inicial"
                prepend-inner-icon="mdi-calendar-outline"
                readonly
                v-on="on"
                dense
                clearable
                outlined
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fecha_inicio"
              @input="dialogFecInicio = false"
              locale="es-mx"
              min="2010-01-01"
              :max="new Date().toISOString().substr(0, 10)"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        <v-col class="" cols="6" md="6">
          <v-menu
            ref="dialogFecInicio"
            v-model="dialogFecFin"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="290px"
            >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fecha_fin"
                label="Fecha Final"
                prepend-inner-icon="mdi-calendar-outline"
                readonly
                v-on="on"
                dense
                outlined
                clearable
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fecha_fin"
              @input="dialogFecFin = false"
              locale="es-mx"
              :min="fecha_inicio"
              :max="new Date().toISOString().substr(0, 10)"
            >
            </v-date-picker>
          </v-menu>
        </v-col>
        </v-row>

        <v-row class="mb-n7">
          <v-col cols="12" sm="6">
            <v-select
              label="Sala"
              dense
              outlined
              v-model="sala_id"
              :items="listSalas"
              prepend-inner-icon="mdi-gavel"
              item-text="nombre"
              item-value="id"
              no-data-text="No hay salas"
              clearable
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6">
            <v-select
              label="Magistrado"
              dense
              outlined
              v-model="magistrado_id"
              :items="listMagistrados"
              item-text="ncompleto"
              item-value="id"
              prepend-inner-icon="mdi-account"
              no-data-text="No hay magistrados"
              clearable
            ></v-select>
          </v-col>
        </v-row>

        <v-row class="mt-n7">
          <v-col cols="12" md="3">
            <v-select
              :items="listMateriasSearch"
              v-model="materia_id"
              label="Materia"
              item-value="id"
              item-text="nombre"
              clearable
              @change="clear"
              dense
              outlined
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="9">
            <v-select
              label="Tipo de Juicio"
              dense
              outlined
              v-model="tipo_juicio_id"
              :items="listTipoJuicios"
              item-text="nombre"
              item-value="id"
              no-data-text="No hay tipo de Juicios"
              :disabled="searchMateria"
              @blur="clearAcciones()"
              clearable
            >
            <template slot="item" slot-scope="data">
              <div class="select-text">
                {{ data.item.nombre }}
              </div>
            </template>
            </v-select>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>

        <v-row class="mt-n7">
          <v-col cols="12" sm="6">
            <v-select
              label="Tipo de Sentencia"
              dense
              outlined
              v-model="tipo_sentencia"
              :items="tipoSentencia"
              item-text="nombre"
              item-value="id"
              clearable
            >
          </v-select>
          </v-col>
          <v-col cols="6">
            <v-select
              label="Sentido de la Sentencia"
              dense
              outlined
              v-model="sentido_id"
              :items="listSentidos"
              item-text="nombre"
              item-value="id"
              clearable
            >
          </v-select>
          </v-col>
        </v-row>

        <v-row class="mt-n7">
          <v-col cols="12" md="12">
            <v-autocomplete
              :items="listDelitosAcciones"
              v-model="delito"
              label="Ingrese la Acción o Delito"
              item-text="nombre"
              return-object
              v-on:change="getAcciones()"
              :disabled="searchMateria"
              :search-input.sync="searchInput"
              no-data-text="No hay Coincidencias"
              clearable
              dense
              outlined
            >
            </v-autocomplete>
          </v-col>
        </v-row>

        <v-row class="mt-n7">
          <v-col cols="12" md="6">
            <v-autocomplete
              :items="listAccionesEspecificas"
              v-model="accion_especifica_id"
              label="Ingrese la Acción Específica"
              item-value="id"
              item-text="nombre"
              no-data-text="No hay Acciones Específicas"
              :disabled="validateDelito"
              clearable
              dense
              outlined
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="12" md="6">
            <v-autocomplete
              :items="listAccionesSimultaneas"
              v-model="accion_simultanea_id"
              label="Ingrese la Acción Simultánea"
              item-value="id"
              item-text="nombre"
              no-data-text="No hay Acciones Simultáneas"
              :disabled="validateDelito"
              clearable
              dense
              outlined
            >
          </v-autocomplete>
          </v-col>
          <v-spacer></v-spacer>
        </v-row>

        <v-flex v-if="validateMenores == true" class="mt-n7">
          <!-- <v-radio-group
            row
            v-model="menores"
            prepend-icon="mdi-human-male-female"
            label=""
            ><label class="body-1">Niños, Niñas y Adolescentes</label>&nbsp;
              <v-radio label="SI" value="1" ></v-radio>
              <v-radio label="NO" value="2"></v-radio>
          </v-radio-group> -->
          <v-checkbox
            prepend-icon="mdi-human-male-female"
            v-model="menores"
            label="Niños, Niñas y Adolescentes"
          ></v-checkbox>
        </v-flex>

        <v-row class="mt-n7">
          <v-col cols="12" sm="6">
            <v-checkbox
              class="text-genero"
              color="purple"
              v-model="perspectiva_genero"
              prepend-icon="mdi-gender-male-female"
              label="Seleccione si la Sentencia fue Juzgada con Perspectiva de Género"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" sm="6">
            <v-checkbox
              class="text-ninez"
              color="#2096F3"
              prepend-icon="mdi-human-child"
              v-model="principio_ninez"
              label="Seleccione si la sentencia fue dictada con Enfoque de Infancia"
            ></v-checkbox>
          </v-col>
        </v-row>

        <v-row>
          <v-spacer></v-spacer>
          <v-col cols="2">
            <v-card-actions>
              <!-- <v-btn v-if="showReporte" dark color="#616161" @click="reportePdf()" class="white--text mt-n9">
                <v-icon>mdi-file-pdf</v-icon>ver reporte
              </v-btn> -->
              <v-btn color="#616161" class="white--text mt-n9" block small @click.native="validate(); $vuetify.goTo(target, options)" :loading="loading">
                <v-icon>mdi-magnify</v-icon>
                 Buscar
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
        <v-divider class="mb-5"></v-divider>

        <v-row>
        <v-col cols="12" ref="resultados">
          <h4 class="overline">Resultados de la consulta</h4>
        </v-col>
        </v-row>

        <div>
          <v-row justify="center">
            <v-col cols="12" sm="6" >
              <v-data-table
                :headers="headers"
                :items="listEstadisticas"
                :items-per-page="5"
                class="elevation-1"
                hide-default-footer
                disable-pagination
                no-data-text="No se Encontraron Resultados"
              >
              <template v-slot:item.total= "{item}">
                <div class="text-right">{{ item.total }}</div>
              </template>
              <template slot="body.append">
              <tr class="brown--text">
                <th><div class="title">Totales</div></th>
                <th><div class="text-right title">{{ sumField('total')}}</div></th>
              </tr>
              </template>
              </v-data-table>
            </v-col>

            <v-col cols="12" sm="6">
              <column-chart
                :data="listTocasTotal"
                :colors="colors"
                label="Total"
                :library="{animation: {duration: 1000}}"
                :messages="{empty: 'No se Encontraron Resultados.'}"
                xtitle="Salas" ytitle="Sentencias"
                >
              </column-chart>
            </v-col>

          </v-row>
        </div>
        <v-dialog
          v-model="progressLoading"
          persistent
          width="300"
        >
          <v-card
            color="#AF8936"
            dark
          >
            <v-card-text>
              <b>DESCARGANDO REPORTE...</b>
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>

      </v-card>

</v-container>

</template>
<script>
import { mapGetters } from 'vuex';

  export default {
    data () {
      return {
        duration: 400,
        offset: 100,
        easing: 'easeInOutCubic',
        type: 'number',
        dialogFecInicio: false,
        dialogFecFin: false,
        fecha_inicio: '',
        fecha_fin:'',
        sala_id: '',
        magistrado_id: '',
        materia_id: '',
        delito: '',
        tipo_sentencia: '',
        tipo_juicio_id: '',
        accion_especifica_id: '',
        accion_simultanea_id: '',
        perspectiva_genero: false,
        principio_ninez: false,
        menores: false,
        sentido_id:'',
        validateMenores: false,
        listDelitosAcciones:[],
        listTipoJuicios:[],
        listAccionesEspecificas:[],
        listAccionesSimultaneas:[],
        listMateriasSearch:[],
        listMaterias:[],
        listTotales:[],
        // listEstadisticas:[],
        listTocasTotal:[],
        listSalasTotal:[],
        // colors:['#AF8936'],
        colors:[['#AF8936', '#607D8B', '#0b6e00', '#006ca2', '#ff3333', '#ff8203', '#9C27B0', '#009688', '#d60001', '#1d2e4c', '#FDD835']],
        progressLoading: false,
        searchMateria: true,
        searchInput:'',
        validateDelito: true,
        validateMateria: true,
        showReporte: false,
        loading:false,
        tipoSentencia: [
          { id: 1, nombre: 'Interlocutoria'},
          { id: 2, nombre: 'Definitiva' }
        ],
        listSentidos: [],
        headers: [
          {
            text: 'Sala',
            align: 'start',
            sortable: false,
            value: 'salas_data.nombre',
            class: "grey-text title"
          },
          { text: 'Total de Tocas', value: 'total',class: "grey-text title", sortable: false, },
        ],
      }
    },
    computed:{
      ...mapGetters([
        "listEstadisticas",
        "listSalas",
        "listMagistrados"
      ]),
      target () {
        const value = this['element']
        if (!isNaN(value)) return Number(value)
        else return value
      },
      options () {
        return {
          duration: this.duration,
          offset: this.offset,
          easing: this.easing,
        }
      },
      element () {
        return this.$refs.resultados
      },
    },
    watch: {
      sala_id (val){
        this.materia_id = ''
        this.tipo_juicio_id = ''
        this.accion_especifica_id = ''
        this.accion_simultanea_id = ''
        this.filterMaterias(val);
        if(!val){
          this.listMateriasSearch = this.listMaterias
          this.sala_id = ''
        }
      },
      delito (val){
        this.validateDelito = false;
        this.showReporte = false
        if(!val){
          this.validateDelito = true;
          this.accion_especifica_id = ''
          this.accion_simultanea_id = ''
          this.showReporte = false
        }
      },
      materia_id (val){
        this.searchMateria = false;
        this.getDelitos();
        if(!val){
          this.delito = '',
          this.searchMateria = true;
        }
      },
      accion_especifica_id (val){
        this.showReporte = false
        if(!val){
          this.showReporte = false
        }
      },
      searchInput: function (value) {
        if(value){
          if (value.length > 3) {
            this.getDelitosFilter(value)
          }
        }
        if (value === 'VIOLENCIA INTRAFAMILIAR' || value === 'FEMINICIDIO') {
          this.validateMenores = true
        } else {
          this.validateMenores = false
          this.menores = ''
        }

        if (!value) {
          this.getDelitos()
          this.validateMenores = false
          this.menores = ''
        }
      },
    },
    mounted(){
      this.getEstadistica()
      this.getMaterias()
      this.getSalas()
      this.getMagistrados()
      this.getSentidos()
    },
    methods:{
      clear(){
        this.delito = ''
        this.accion_especifica_id = ''
        this.accion_simultanea_id = ''
        this.tipo_juicio_id = ''
        this.showReporte = false
        if (this.materia_id) {
          this.tipoJuicio()
        }
      },
      clearAcciones () {
        if (!this.tipo_juicio_id) {
          this.accion_especifica_id = ''
          this.accion_simultanea_id = ''
        }
      },
      sumField(key) {
        // sum data in give key (property)
        return this.listEstadisticas.reduce((a, b) => a + (b[key] || 0), 0)
      },
      validate(){
        this.listTocasTotal = []
        this.loading = true
        this.getEstadistica()
      },
      getEstadistica() {
        // this.colors = []
        var delito_id = ''
        if (this.delito) {
          delito_id = this.delito.id
        }
        // this.listEstadisticas = []
        this.$store.dispatch("GET_ESTADISTICAS",  { url: "/tocas/estadisticas",
          data: {
            fecha_ini: this.fecha_inicio,
            fecha_fin: this.fecha_fin,
            sala_id: this.sala_id,
            magistrado_id: this.magistrado_id,
            materia_id: this.materia_id,
            tipo_juicio_id: this.tipo_juicio_id,
            tipo_sentencia: this.tipo_sentencia,
            delito_id: delito_id,
            accion_especifica_id: this.accion_especifica_id,
            accion_simultanea_id: this.accion_simultanea_id,
            materia_id: this.materia_id,
            perspectiva_genero: this.perspectiva_genero,
            principio_ninez: this.principio_ninez,
            menores:this.menores,
            sentido_id:this.sentido_id,
          }
        })
        .then(response => {
          // console.log(response.data.data);
          // this.listEstadisticas = response.data.data.tocas
          this.loading = false
          this.showReporte = true
          this.listEstadisticas.forEach((item, i) => {
            this.listSalasTotal.push('sala '+item.sala_id)
            this.listSalasTotal.push(item.total)
            this.listTocasTotal.push(this.listSalasTotal)
            this.listSalasTotal = []
          });
        })
        .catch(error => {
          console.log(error);
        });
      },
      getMaterias() {
        this.loading = true;
        this.$store.dispatch("GET_MATERIAS",  { url: "/materias" } ).then(response => {
          this.listMaterias = response.data.data.materias;
          this.listMateriasSearch = response.data.data.materias;
          // console.log(response.data.data.materias);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      filterMaterias(val){
        this.listMateriasSearch = [];
        var materias = this.listMaterias;
        // console.log(materias);
        materias.forEach(materia => {
          if ((val == 1 || val == 2 || val == 6 || val == 10 || val == 11) && (materia.id == 4)) {
              this.listMateriasSearch.push(materia)
              this.materia_id = ''
            }
          if ((val == 3 || val == 4 || val == 5 || val == 7 || val == 8 || val == 9) && (materia.id == 3 || materia.id == 2 || materia.id == 1)) {
              this.listMateriasSearch.push(materia)
              this.materia_id = ''
            }
          });
          // console.log(this.listMateriasSearch);
      },
      getDelitos() {
        this.$store.dispatch("GET_DELITOS",  { url: "/delitos-total",
          data: {
            materia_id:this.materia_id,
          }
          }).then(response => {
          this.listDelitosAcciones = response.data.data.delitos;
          // console.log(response.data);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getDelitosFilter(value) {
        this.$store.dispatch("GET_DELITOS",  { url: "/delitos-total",
          data: {
            materia_id:this.materia_id,
            nombre_delito: value
          }
          }).then(response => {
          this.listDelitosAcciones = response.data.data.delitos;
          // console.log(response.data.data);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      tipoJuicio() {
        // this.loading = true;
        this.$store.dispatch("GET_TIPO_JUICIO",  { url: "/materia/"+this.materia_id+"/tipo-juicios" } ).then(response => {
          // console.log(response.data);
          this.listTipoJuicios = response.data.data.tipo_juicios;
          // this.listDelitos = response.data.data.delitos;
          // this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getAcciones(){
        if (this.delito) {
          this.getEspecificas()
          this.getSimultaneas()
        }
      },
      getEspecificas() {
        var delito_id = ''
        if (this.delito) {
          delito_id = this.delito.id
        }
        this.$store.dispatch("GET_ACCIONES_ESPECIFICAS",  { url: "/delito/"+delito_id+"/acciones-especificas",
          }).then(response => {
            // console.log(response.data.data.acciones_especificas);
          this.listAccionesEspecificas = response.data.data.acciones_especificas;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getSimultaneas() {
        this.$store.dispatch("GET_ACCIONES_SIMULTANEAS",  { url: "/delito/"+this.delito.id+"/acciones-simultaneas",
          }).then(response => {
            // console.log(response.data.data.acciones_simultaneas);
          this.listAccionesSimultaneas = response.data.data.acciones_simultaneas;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getSalas() {
        // if (this.currentUser.id > 2) {
        //   this.getMaterias();
        // }
        this.loading = true;
        this.$store.dispatch("GET_SALAS",  { url: "/salas" } ).then(response => {
          // console.log(response.data);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getMagistrados() {
        this.loading = true;
        this.$store.dispatch("GET_MAGISTRADOS",  { url: "/magistrados" } ).then(response => {
          // console.log(response.data);
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
      },
      getSentidos() {
        this.$store.dispatch("GET_SENTIDOS_CATALOGO",  { url: "/sentidos-activos",
          }).then(response => {
          this.listSentidos = response.data.data.sentidos;
          // console.log(response.data);
        })
        .catch(error => {
          console.log(error);
        });
      },
      reportePdf(){
        var delito_id = ''
        if (this.delito) {
          delito_id = this.delito.id
        }
        this.progressLoading = true
        this.$store.dispatch("GET_PDF", { url:"/tocas/reporteTocas",
          data: {
            materia_id: this.materia_id,
            delito_id: delito_id,
            accion_especifica_id: this.accion_especifica_id,
          }
        }).then((response) => {
          this.progressLoading = false
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
          const link = document.createElement('a');
          link.href = url;
          let inicio = this.fecha_inicio
          let fin = this.fecha_fin
          link.setAttribute('download', 'Reporte.pdf');
          document.body.appendChild(link);
          link.click();
        })
        .catch(err => {
          console.log(err);
          this.progressLoading = false
          this.$swal({
            title: 'Error al descargar el PDF!!!',
            icon: 'error',
            timer: 1000,
          })
        });
      }
      // rnd (a, b) {
      //   return Math.floor((b - a + 1) * Math.random()) + a
      // },
    }

  }
</script>

<style scoped>
  .select-text {
    font-size: 13px;
    font-weight: 500;
  }
  .text-genero /deep/ label {
    color: purple;
    font-weight: bold;
  }
  .text-ninez /deep/ label {
    color: #2096F3;
    font-weight: bold;
  }
</style>
